export default {
      id: "vagues_kiosque-usage",
      viewBox: "0 0 1135 225",
      url: "../dist/images/" + "sprite.svg#vagues_kiosque-usage",
      toString: function () {
        return this.url;
      }
    }